import React, { Fragment, useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { hideSpinner, showSpinner } from "../../../../../store/actions/loading";
import { Paginator } from '../../../../layout/Paginator/Paginator';
import { Search } from '../../../../layout/Table/Search';
import { TableComponent } from "./Table";
import { store } from '../../../../../store/store';
import { hideNotification } from '../../../../../store/actions/notification';
import { RowsPerPage } from "../../../../layout/Table/RowsPerPage";
import { getAppointmentHolidays as getAppointmentHolidaysApi } from "../../../../../api/appointmentHolidays/appointmentHolidays";
import { CalendarButton } from '../../calendar/CalendarButton';
import { FILTER_TYPES } from '../../../../../config/constants';
import { APPOINTMENT_HOLIDAY_FILTERS, APPOINTMENT_HOLIDAY_FILTERS_NAMES } from '../../../../../config/constants/Appointments/appointments_constants';
import { FiltersTableList } from '../../../../../components/layout/Paginator/FiltersTableList';
import { useUpdateEffect } from '../../../../../helpers/hooks';
import moment from 'moment';
import { ListToolbar } from '../../../../layout/Workspace';

let oneTimeCall = false;
function AppointmentHolidaysTableComponent(props) {
  const [ sortDirection, setSortDirection ] = useState( null );
  const [ sortField, setSortField ] = useState( null );
  const [ searchText, setSearchText ] = useState( null );
  const [ appointmentHolidays, setAppointmentHolidays ] = useState( null );
  const [ meta, setMeta ] = useState( null );
  const [ rowsPerPage, setRowsPerPage ] = useState( 5 );
  const { refreshTable } = props;
  const [ dateFilter, setDateFilter ] = useState({
    intervalFrom: '',
    intervalTo: '',
  });
  const [ displayDateFilters, setDisplayDateFilters ] = useState( {} );
  const [ page, setPage ] = useState( null );
  const calendarButtonDayAsTimestampRef = useRef();

  useEffect( () => {
    getAppointmentHolidays( 1 );

    return () => {
      store.dispatch(hideNotification());
    }
  }, [] ); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect( () => {
    getAppointmentHolidays(1, sortField, sortDirection, searchText);

    return () => {
      store.dispatch(hideNotification());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPage] );

  useEffect( () => {
    if (meta) {
      getAppointmentHolidays(meta.current_page, sortField, sortDirection, searchText);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshTable])

  useUpdateEffect( () => {
    getAppointmentHolidays( page, sortField, sortDirection, searchText );
  }, [ page, sortField, sortDirection, searchText, rowsPerPage, dateFilter ] );

  /**
   * Get appointmentHolidays
   * @param {number} [page]
   * @param {string} [sortField]
   * @param {string} [sortDirection]
   * @param {string} [searchText]
   * @param {boolean} [hideNotification]
   */
  const getAppointmentHolidays = (page, sortField, sortDirection, searchText, hideNotification = false) => {
    if (oneTimeCall === true) {
      return;
    }
    
    oneTimeCall = true;

    const intervalFrom = moment( dateFilter?.intervalFrom ).startOf( 'day' );
    const intervalTo = moment( dateFilter?.intervalTo ).endOf( 'day' );

    const _dateFilter = {
      intervalFrom: intervalFrom?.isValid() ? intervalFrom?.unix() : '',
      intervalTo: intervalTo?.isValid() ? intervalTo?.unix() : '',
    };

    getAppointmentHolidaysApi( {
      pagination: {
        page: page,
        sort_by: sortField,
        sort: sortDirection,
        q: searchText,
        per_page: rowsPerPage,
        ..._dateFilter,
      },
      hideNotification: hideNotification
    } ).then(
      response => {
        if (! response || ! response?.data?.data) {
          return;
        }

        setAppointmentHolidays( response.data.data );
        setMeta( response.data.meta );
        props.hideSpinner();
      }
    ).finally(() => {
      oneTimeCall = false;
    });
  };

  /**
   * Apply sort by appliedSortField
   * @param {string} appliedSortField
   */
  function applySort(appliedSortField) {
    let newSortDirection = "";

    if (sortField) {
      if (sortField === appliedSortField) {
        newSortDirection = sortDirection === "asc" ? "desc" : "asc";
      } else {
        newSortDirection = "asc";
      }
    } else {
      newSortDirection = "asc";
    }

    setSortField( appliedSortField );
    setSortDirection( newSortDirection );

    getAppointmentHolidays(meta.current_page, appliedSortField, newSortDirection, searchText, true);

  }

  const applyDateFilters = (selectedFilters) => {
    setPage( 1 );

    if (selectedFilters.entity === 'day_as_timestamp') {
      setDisplayDateFilters( prevState => ( {
        ...prevState,
        dayAsTimestampFilters: selectedFilters
      } ) );
    }
  };

  const removeDateFilter = (entity) => {
    setPage( 1 );
  
    switch (entity) {
      case 'all': {
        setDateFilter( {
          intervalFrom: '',
          intervalTo: '',
        } );
        setDisplayDateFilters( {} );

        break;
      }
      case 'day_as_timestamp': {
        setDateFilter( prevDateFilter => ( {
          ...prevDateFilter,
          intervalFrom: '',
          intervalTo: '',
        } ) );

        setDisplayDateFilters( (prevState) => {
          const { dayAsTimestampFilters, ...updatedState } = prevState;

          return updatedState;
        } );
        break;
      }
      default : {
        setDateFilter( {
          intervalFrom: '',
          intervalTo: '',
        } );
        setDisplayDateFilters( {} );

        break;
      }
    }

    resetDatePickerSelectedRange( entity );
  }

  const resetDatePickerSelectedRange = (entity) => {
    switch (entity) {
      case 'all': {
        if (calendarButtonDayAsTimestampRef.current && calendarButtonDayAsTimestampRef.current.onReset) {
          calendarButtonDayAsTimestampRef.current.onReset();
        }

        break;
      }

      case 'day_as_timestamp': {
        if (calendarButtonDayAsTimestampRef.current && calendarButtonDayAsTimestampRef.current.onReset) {
          calendarButtonDayAsTimestampRef.current.onReset();
        }

        break;
      }

      default: {
        if (calendarButtonDayAsTimestampRef.current && calendarButtonDayAsTimestampRef.current.onReset) {
          calendarButtonDayAsTimestampRef.current.onReset();
        }

        break;
      }
    }

  };

  const removeAllFilters = () => {
    setPage( 1 );

    setDateFilter( {
      intervalFrom: '',
      intervalTo: '',
    } );

    removeDateFilter( 'all' );
    resetDatePickerSelectedRange();
  };

  return (
    <Fragment>
      <ListToolbar
        activeFilters={(
          <FiltersTableList
            id="archive-filters"
            filters={[]}
            selectedDateFilters={displayDateFilters}
            filtersApplied={false}
            onRemoveFilter={() => {}}
            removeDateFilter={removeDateFilter}
            onRemoveAllFilters={removeAllFilters}
          />
        )}
        className="appointment-settings-list-toolbar"
        search={(
            <Search
              id="appointmentHoliday"
              search={searchText => {
                setSearchText( searchText );
                getAppointmentHolidays( 1, null, null, searchText, true);
              }}
              colSize={12}
            />
        )}
        settings={(
          <CalendarButton
              applyDateFilters={applyDateFilters}
              filterKey={APPOINTMENT_HOLIDAY_FILTERS.byDayAsTimestamp}
              name={APPOINTMENT_HOLIDAY_FILTERS_NAMES.byDayAsTimestamp}
              shortName={APPOINTMENT_HOLIDAY_FILTERS_NAMES.byDayAsTimestamp}
              type={FILTER_TYPES.DATE}
              setDateFilter={(fromDate, toDate) => {
                setDateFilter( prevDateFilter => ( {
                  ...prevDateFilter,
                  intervalFrom: fromDate,
                  intervalTo: toDate,
                } ) );
              }}
              dateFilter={dateFilter}
              displayDateFilters={displayDateFilters}
              tooltip='day_as_timestamp'
              entity='day_as_timestamp'
              ref={calendarButtonDayAsTimestampRef}
              datePickerEndDate={new Date(new Date().setFullYear(new Date().getFullYear() + 10))}
              datePickerStartDate={2020}
          />
        )}
      />
      <TableComponent
        applySort={ sortField => applySort( sortField ) }
        appointmentHolidays={ appointmentHolidays }
        actionCallback={
          useState => {
            if (useState) {
              getAppointmentHolidays(meta.current_page, sortField, sortDirection, searchText);
            } else {
              getAppointmentHolidays();
            }
          }
        }
      />
      <Paginator
        meta={ meta }
        settings={(
          <RowsPerPage
            id="appointmentHoliday"
            changeRowsPerPage={
              (rowsPerPage) => {
                setRowsPerPage(rowsPerPage);
              }
            }
            rowsPerPage={5}
          />
        )}
        changePage={ page => getAppointmentHolidays(page, sortField, sortDirection, searchText, true) }
      />
    </Fragment>
  )
}

const AppointmentHolidaysTable = connect(null, { showSpinner, hideSpinner })(AppointmentHolidaysTableComponent);

export { AppointmentHolidaysTable, AppointmentHolidaysTableComponent };
